var React = require('react');

function Section1MobileBottomLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.1329 8.26573C29.4154 8.26573 31.2657 6.41538 31.2657 4.13286C31.2657 1.85035 29.4154 0 27.1329 0C24.8503 0 23 1.85035 23 4.13286C23 6.41538 24.8503 8.26573 27.1329 8.26573Z","fill":"#E9D8FD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.6792 70.004L2.84272 48.5896L20.7255 33.0001L33.6792 70.004Z","fill":"#C5F6D5","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30 55C33.866 55 37 51.866 37 48C37 44.134 33.866 41 30 41C26.134 41 23 44.134 23 48C23 51.866 26.134 55 30 55Z","fill":"#F58C8C","key":2})]);
}

Section1MobileBottomLeftInline.defaultProps = {"width":"37","height":"78","viewBox":"0 0 37 78","fill":"none"};

module.exports = Section1MobileBottomLeftInline;

Section1MobileBottomLeftInline.default = Section1MobileBottomLeftInline;
